export default __webpack_public_path__ + "38238f3fa14698c7d8e8b5711236d2e4.png";